export function safeDivide(a: number, b: number, fallback = 0): number {
  if (a && b) {
    return a / b;
  }
  return fallback;
}

export function percentage(a: number, b: number): string {
  return `${Math.round(safeDivide(100 * a, b))}%`;
}
